<template>
  <div class="call-center-list container">
    <breadcrumb crumb="call-center" />
    <search-filters @search="onSearch" @set="setModal" />
    <el-table
      v-if="loading || !list.length"
      v-loading="loading"
      :data="list"
      style="width: 100%; height: 40vh"
    />
    <el-collapse-transition v-if="list.length && !loading">
      <section class="container">
        <list-titles :titles="titles">
          <el-checkbox
            v-model="checkAll"
            :indeterminate="indeterminate"
            @change="onCheckAll"
          />
        </list-titles>
        <el-checkbox-group v-model="checked" @change="onCheckOne">
          <cci-item v-for="i in list" :key="i.id" :item="i" @set="setModal" />
        </el-checkbox-group>
        <div class="pagination bottom-section">
          <pagination :data="pagination" @changed="changePage" />
        </div>
      </section>
    </el-collapse-transition>
    <add-contacts-modal :id="id" :visible="addContactModal" @set="setModal" />
    <contacts-modal :id="id" :visible="contactsModal" @set="setModal" />
    <call-modal :id="id" :visible="callModal" @set="setModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { titlesTasks } from '@/views/CallCenter/constants'
import AddContactsModal from './components/Modals/AddContactsModal'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import CallModal from './components/Modals/CallModal'
import CciItem from './components/CCItem'
import ContactsModal from './components/Modals/ContactsModal'
import ListTitles from '@/components/Tables/ListTitles'
import Pagination from '@/components/Tables/PaginationCustom'
import SearchFilters from './components/SearchFilters'

export default {
  name: 'CallCenter',
  components: {
    Breadcrumb,
    CciItem,
    Pagination,
    SearchFilters,
    ListTitles,
    AddContactsModal,
    ContactsModal,
    CallModal,
  },
  data() {
    return {
      search: {},
      page: 1,
      checked: [],
      checkAll: false,
      indeterminate: false,
      addContactModal: false,
      contactsModal: false,
      callModal: false,
      id: 0,
      titles: titlesTasks,
    }
  },
  created() {
    this.fetchList()
    this.fetchAdmins()
  },
  computed: {
    ...mapGetters({
      getList: 'callCenter/getList',
      getPagination: 'callCenter/getPagination',
      getLoading: 'callCenter/getLoading',
    }),
    list() {
      return this.getList('tasks')
    },
    loading() {
      return this.getLoading()
    },
    pagination() {
      return this.getPagination('Cont')
    },
  },
  methods: {
    ...mapActions({
      fetchTasks: 'callCenter/fetchTasks',
      fetchAdmins: 'callCenter/fetchAdmins',
    }),
    fetchList() {
      const { search, page } = this

      this.fetchTasks({ ...search, page })
    },
    onSearch(search = {}) {
      this.search = search
      this.fetchList()
    },
    changePage(page = 1) {
      this.page = page
      this.fetchList()
    },
    onCheckAll(val) {
      this.checked = val ? this.list.map(f => f.id) : []
      this.indeterminate = false
    },
    onCheckOne(val) {
      const checkedCount = val.length

      this.checkAll = checkedCount === this.list.length
      this.indeterminate = checkedCount > 0 && checkedCount < this.list.length
    },
    setModal(key, id) {
      this[key] = Boolean(id)

      if (id) {
        this.id = id
      }
    },
  },
}
</script>

<style lang="sass">
.call-center-list
  font-size: 14px
  color: #000
  .search-row
    margin-bottom: 30px
</style>
